import { SET_DATA_SEARCH, SET_IMAGE_KPI } from "./mutation-types";

export default {
  [SET_DATA_SEARCH](state, ordersKey) {
    state.searchDataKeys = Object.keys(ordersKey);
  },
  [SET_IMAGE_KPI](state, arrayKPI) {
    state.imagesKPI = arrayKPI;
  }
};
